import { render, staticRenderFns } from "./serach.vue?vue&type=template&id=d0989f70&scoped=true&"
import script from "./serach.vue?vue&type=script&lang=js&"
export * from "./serach.vue?vue&type=script&lang=js&"
import style0 from "./serach.vue?vue&type=style&index=0&id=d0989f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0989f70",
  null
  
)

export default component.exports